import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from "@angular/forms";
import { Router, NavigationEnd } from "@angular/router";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    providers: [Title]
})

export class LoginComponent implements OnInit {

    loginForm: FormGroup;
    today = Date.now();

    constructor(private fb: FormBuilder, private router: Router, private title: Title) {
        this.title.setTitle('Sun Life Find My Shares Portal');
    }

    ngOnInit() {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0)
        });

        this.loginForm = this.fb.group({
            'userName': new FormControl(null),
            'password': new FormControl(null)
        });

    }

    onNavigateNext() {
        this.router.navigate(['reporting/applications']);
    }

}
